import { DocumentNode } from "graphql";
import { client_product } from "../client"; // adjust path as needed
import {
  GET_CATEGORY_BY_ID,
  GET_VENDOR_BY_ID,
  GET_SHOP_BY_ID,
} from '../productGQL';

export const fetchEntityById = async (
  type: 'category' | 'vendor' | 'shop',
  id: string
) => {
  if (type === 'category') {
    const res = await executeGraphQL<{ getCategoryById: any }>(GET_CATEGORY_BY_ID, { id });
    return res.getCategoryById;
  } else if (type === 'vendor') {
    const res = await executeGraphQL<{ getVendorById: any }>(GET_VENDOR_BY_ID, { vendorId: id });
    return res.getVendorById;
  } else if (type === 'shop') {
    const res = await executeGraphQL<{ getShopById: any }>(GET_SHOP_BY_ID, { shopId: id });
    return res.getShopById;
  }
};
// Generic function using ApolloClient
export const executeGraphQL = async <T>(
  query: DocumentNode,
  variables: Record<string, any> = {}
): Promise<T> => {
  try {
    const { data, errors } = await client_product.query<T>({
      query,
      variables,
      fetchPolicy: "no-cache", // Optional: change to 'cache-first' if you want caching
    });

    if (errors && errors.length > 0) {
      throw new Error(errors[0].message);
    }

    return data;
  } catch (error: any) {
    throw new Error(error.message || "GraphQL request failed");
  }
};
